import script from "./widgetDesc.vue?vue&type=script&lang=js"
export * from "./widgetDesc.vue?vue&type=script&lang=js"

import "./widgetDesc.vue?vue&type=style&index=0&id=fa314436&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa314436"],['__file',"src/components/widgets/widgetDesc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa314436"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa314436', __exports__)) {
    api.reload('fa314436', __exports__)
  }
  
}


export default __exports__